module.exports = __webpack_public_path__ + "static/img/shi1_1.145ff66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi1_1.png
// module id = XOQi
// module chunks = 1